import { GeneralSearchSheetsUseCase } from '@core/design-system/search';
import { ISearchUseCaseResponse } from '@mais-retorno-front/components/general-search/interface';

/**
 * Returns the results of general search but with FUNDS category in first place
 */
export class GeneralSearchAssetsToComparisonFundsUseCase {
  constructor() {}

  async execute(term: string) {
    const results = await new GeneralSearchSheetsUseCase(true, true).execute(
      term
    );

    const fundCategoryIndex = results.categories.findIndex((category) =>
      category.label.includes('Fundo')
    );

    const DTO = {
      categories: results.categories,
      groupedAssets: Object.entries(results.groupedAssets).reduce(
        (acc, [category, list]) => {
          return {
            ...acc,
            [category]: list.map(
              (asset) =>
                ({
                  ...asset.toJson(),
                  url: asset.canonical_url,
                  enable: !asset.isDisabled(true),
                } as any)
            ),
          };
        },
        {}
      ),
    };

    if (fundCategoryIndex === -1) {
      return DTO;
    }

    const [fundCategory] = results.categories.splice(fundCategoryIndex, 1);
    results.categories = [fundCategory, ...results.categories];

    return DTO as ISearchUseCaseResponse;
  }
}
